// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2P3az","itemSelecionado":"Item_itemSelecionado__3jCs2","itemCompletado":"Item_itemCompletado__16K-n","concluido":"Item_concluido__cEont"};